import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbaniaonrentinsatara() {



    const cardData =
    {
        keyword: 'Force Urbania On Rent in Satara',
        heading: 'Urbania on rent in pune: Force Urbania On Rent in Satara',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Force Urbania On Rent in Satara services for corporate groups, families, tourists, and event travelers planning trips to and from Satara. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for long‑distance travel, weekend getaways, corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune to Satara. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Force Urbania hire in Satara.',

        top: 'Top Places to Visit in Satara with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Kaas Plateau (Kaas Pathar)",
    "description": "Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Heritage Site near Satara. It blooms with a vibrant variety of wildflowers during the monsoon season, creating a stunning carpet of colors. The plateau is home to endemic species of flora and fauna, trekking trails, and viewpoints that offer panoramic vistas of the surrounding Western Ghats. It is a paradise for nature lovers, photographers, and botanists."
  },
  {
    "title": "Ajinkyatara Fort",
    "description": "Ajinkyatara Fort, perched on a hill overlooking Satara city, is a historic Maratha fort built during the reign of Chhatrapati Shivaji Maharaj. It played a strategic role in Maratha history and offers panoramic views of the city, Krishna river, and surrounding hills. The fort attracts trekkers, history enthusiasts, and photographers seeking sunset views and scenic landscapes."
  },
  {
    "title": "Thoseghar Waterfalls",
    "description": "Thoseghar Waterfalls is a spectacular natural attraction located about 20 km from Satara. During the monsoon, the falls are at their most magnificent, cascading down rocky cliffs into deep gorges. The surrounding area has lush greenery, trekking paths, and viewpoints perfect for nature lovers and photography enthusiasts. It is considered one of the most beautiful waterfalls in Maharashtra."
  },
  {
    "title": "Yavateshwar Temple",
    "description": "Yavateshwar Temple is an ancient Shiva temple located near Satara, known for its spiritual significance and serene surroundings. The temple features traditional architecture, peaceful courtyards, and scenic hill views. Devotees visit for worship and to enjoy the tranquility of the location, making it a cultural and spiritual landmark of Satara."
  },
  {
    "title": "Sajjangad Fort",
    "description": "Sajjangad Fort is a hill fort situated near Satara and is famous as the final resting place of Saint Ramdas, spiritual guru of Chhatrapati Shivaji Maharaj. The fort attracts devotees, trekkers, and history enthusiasts. It offers panoramic views of the Sahyadri ranges, serene surroundings, and glimpses of Maratha history and architecture."
  },
  {
    "title": "Koyna Dam",
    "description": "Koyna Dam, located on the Koyna River, is one of Maharashtra’s largest dams and a major hydropower project. Surrounded by scenic hills and dense forests, it is a favorite spot for picnics, nature walks, and photography. The dam and reservoir area offer a peaceful environment, especially during the monsoon, making it a top leisure and sightseeing destination near Satara."
  },
  {
    "title": "Chandan Fort",
    "description": "Chandan Fort, located in Satara district, is a historic fort known for its Maratha-era architecture and strategic location. Trekking to the fort offers breathtaking views of surrounding valleys, hills, and villages. The fort attracts history buffs, trekkers, and adventure seekers looking for a scenic and culturally enriching experience."
  },
  {
    "title": "Sajjangad Wildlife Sanctuary",
    "description": "Sajjangad Wildlife Sanctuary near Satara preserves the biodiversity of the Western Ghats. It is home to a variety of bird species, reptiles, and small mammals. Visitors can enjoy nature walks, bird watching, and scenic views. The sanctuary provides an opportunity to connect with the region’s natural environment and promotes eco-tourism."
  },
  {
    "title": "Lotus Lake",
    "description": "Lotus Lake is a serene waterbody near Satara, famous for its blooming lotus flowers during the monsoon season. Surrounded by greenery and small hills, it is ideal for photography, picnics, and relaxing boat rides. The calm environment and natural beauty make it a favorite local escape."
  },
  {
    "title": "Vasota Fort",
    "description": "Vasota Fort, located amidst the dense forests of Satara, is an adventurous trekking destination for history and nature enthusiasts. Surrounded by the Koyna Wildlife Sanctuary, the fort offers panoramic views of the Western Ghats, waterfalls, and dense greenery. It combines historical significance with the thrill of offbeat trekking."
  }
],






"services": [
{
"name": "Force Urbania on Rent in Satara",
"description": "Force Urbania on Rent in Satara offers well-maintained Urbania buses for local and outstation travel. Ideal for families, corporate groups, and tourists, these buses provide comfortable seating, professional chauffeurs, and a hassle-free journey across Satara and nearby destinations."
},
{
"name": "Satara Urbania Bus Hire",
"description": "Satara Urbania Bus Hire provides convenient rental services with AC and non-AC Urbania buses for city travel, sightseeing, and group tours. Perfect for families, corporate trips, and friends seeking comfort, safety, and timely travel."
},
{
"name": "Urbania Rental Service Satara",
"description": "Urbania Rental Service Satara offers flexible rental options for Urbania buses with experienced drivers, suitable for corporate events, family outings, weddings, and outstation trips. Ensures reliability and comfort for all passengers."
},
{
"name": "Urbania AC Bus on Rent Satara",
"description": "Urbania AC Bus on Rent Satara provides fully air-conditioned Urbania buses for comfortable city travel, corporate trips, and long-distance journeys. Features climate-controlled interiors and professional chauffeurs for a smooth ride."
},
{
"name": "Corporate Urbania Hire Satara",
"description": "Corporate Urbania Hire Satara delivers professional transport solutions for business travel, office events, and employee commutes. Includes AC buses, punctual service, and trained drivers for a seamless corporate experience."
},
{
"name": "Urbania for Outstation Satara",
"description": "Urbania for Outstation Satara offers AC and non-AC buses for long-distance travel, weekend getaways, sightseeing tours, and intercity trips. Ensures comfortable seating, luggage support, and courteous drivers familiar with the routes."
},
{
"name": "Urbania Airport Transfer Satara",
"description": "Urbania Airport Transfer Satara provides timely pick-up and drop services to and from Satara Airport. Ideal for tourists, corporate travelers, and families seeking stress-free, reliable, and comfortable airport transport."
},
{
"name": "Luxury Force Urbania Satara",
"description": "Luxury Force Urbania Satara offers high-end, air-conditioned buses with plush seating, modern interiors, and professional drivers. Perfect for VIP travel, weddings, corporate outings, and luxury family trips."
},
{
"name": "Affordable Urbania Hire Satara",
"description": "Affordable Urbania Hire Satara provides budget-friendly rental options for city travel, sightseeing, and group outings without compromising on comfort, safety, or convenience."
},
{
"name": "Chauffeur Driven Force Urbania Satara",
"description": "Chauffeur Driven Force Urbania Satara ensures a stress-free travel experience with verified and experienced drivers. Ideal for families, corporate groups, and tourists looking for safe and reliable transport across Satara."
},
{
"name": "Urbania for Wedding Events Satara",
"description": "Urbania for Wedding Events Satara offers spacious and air-conditioned buses for wedding guests and party travel. Ensures punctual service, comfort, and elegance for special celebrations."
},
{
"name": "Urbania for Office Trips Satara",
"description": "Urbania for Office Trips Satara provides organized and professional transport for corporate outings, team trips, and business travel. Features AC buses, comfortable seating, and trained chauffeurs for smooth office travel."
},
{
"name": "Best Urbania Rental Satara",
"description": "Best Urbania Rental Satara offers top-rated Urbania buses with excellent customer service, timely pickups, and comfortable travel for both local and outstation trips. Suitable for families, corporate groups, and tourists."
},
{
"name": "Urbania Group Travel Satara",
"description": "Urbania Group Travel Satara provides large-capacity buses for group outings, excursions, and tours. Ensures safe, comfortable, and convenient travel for friends, families, and corporate groups."
},
{
"name": "Reliable Urbania Hire Satara",
"description": "Reliable Urbania Hire Satara offers dependable and punctual Urbania bus services for city and outstation travel. Known for safety, comfort, and professional drivers, making group travel seamless and enjoyable."
}
],
"tableData": [
["Force Urbania on Rent in Satara", "Satara Urbania Bus Hire"],
["Urbania Rental Service Satara", "Urbania AC Bus on Rent Satara"],
["Corporate Urbania Hire Satara", "Urbania for Outstation Satara"],
["Urbania Airport Transfer Satara", "Luxury Force Urbania Satara"],
["Affordable Urbania Hire Satara", "Chauffeur Driven Force Urbania Satara"],
["Urbania for Wedding Events Satara", "Urbania for Office Trips Satara"],
["Best Urbania Rental Satara", "Urbania Group Travel Satara"],
["Reliable Urbania Hire Satara", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Force Urbania On Rent in Satara",
        "WhyChoosedescription": "Force Urbania On Rent in Satara is ideal for group travel, family outings, corporate trips, weddings, and outstation journeys, providing comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Force Urbania Vehicles",
        "WhyChoosedescription": "Force Urbania On Rent in Satara offers modern vehicles with air-conditioning, ample legroom, and comfortable seating for long and short trips."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "All Urbania vehicles come with skilled drivers familiar with Satara, Pune, and nearby routes, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Force Urbania On Rent in Satara for competitive rates with no hidden charges, making group and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Force Urbania On Rent in Satara provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Force Urbania On Rent in Satara is available for hourly rentals, full-day bookings, multi-day trips, corporate travel, sightseeing tours, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Force Urbania On Rent in Satara are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Force Urbania On Rent in Satara guarantees on-time pickups and dependable service, ensuring smooth and stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Force Urbania On Rent in Satara available for local and outstation travel?',
        answer: 'Yes, Force Urbania On Rent in Satara can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Force Urbania On Rent in Satara?',
        answer: 'You can book Force Urbania On Rent in Satara via phone, WhatsApp, or online for quick and easy reservations.',
    },
    {
        question: 'Why choose Force Urbania On Rent in Satara?',
        answer: 'Force Urbania On Rent in Satara offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Force Urbania On Rent in Satara are licensed, trained, and experienced in handling Force Urbania vehicles safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Force Urbania On Rent in Satara allows flexible pickup and drop locations across Satara and nearby areas.',
    },
    {
        question: 'Is Force Urbania On Rent in Satara available 24x7?',
        answer: 'Yes, Force Urbania On Rent in Satara operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all vehicles are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Force Urbania On Rent in Satara accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Force Urbania On Rent in Satara is ideal for group trips, corporate travel, family outings, and long-distance journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Manoj Patil',
        feedback: 'Force Urbania On Rent in Satara provided a smooth and comfortable ride for our family trip. Spacious and reliable service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Deshmukh',
        feedback: 'We hired Force Urbania On Rent in Satara for a corporate outing. Clean, punctual, and excellent service.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rajesh Kulkarni',
        feedback: 'Force Urbania On Rent in Satara made our group travel hassle-free and enjoyable. Highly recommended.',
        rating: 5,
    },
];



































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania On Rent in Satara",
  "image": "https://urbaniaonrentpune.in/assets/images/force-urbania-satara.jpg",
  "description": "Force Urbania On Rent in Satara offers AC and non-AC Force Urbania buses for corporate travel, outstation trips, airport transfers, weddings, office trips, and group travel. Chauffeur-driven Force Urbania buses provide safe, comfortable, and reliable transportation across Satara and nearby areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/force-urbania-on-rent-satara"
  }
};





    return (
        <div>
            <Helmet>
  <title>
    Call:+91 9209423113 | Force Urbania On Rent in Satara | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Force Urbania On Rent in Satara for corporate travel, outstation trips, airport transfers, weddings, office trips, and group travel. AC and non-AC Force Urbania buses with chauffeur-driven service ensure safe, comfortable, and reliable transportation in Satara."
  />

  <meta
    name="keywords"
    content="Force Urbania on Rent in Satara, Satara Urbania Bus Hire, Urbania Rental Service Satara, Urbania AC Bus on Rent Satara, Corporate Urbania Hire Satara, Urbania for Outstation Satara, Urbania Airport Transfer Satara, Luxury Force Urbania Satara, Affordable Urbania Hire Satara, Chauffeur Driven Force Urbania Satara, Urbania for Wedding Events Satara, Urbania for Office Trips Satara, Best Urbania Rental Satara, Urbania Group Travel Satara, Reliable Urbania Hire Satara"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/79.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Forceurbaniaonrentinsatara;